import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { fetchRequest } from '@tk/utilities/tk.fetch';

interface AsyncFormResponse {
    redirectURL: string;
}

export default class TKAsyncForm extends TKCustomElementFactory {
    form?: HTMLFormElement;
    outputAsJSON: boolean = false;
    jsonKey: string;

    constructor() {
        super();

        this.form = this.querySelector('[data-tk-form]') || undefined;
        this.outputAsJSON = this.hasAttribute('data-tk-output-as-json');
        this.jsonKey = this.getAttribute('data-tk-output-as-json') || 'value';
    }

    connectedCallback(): void {
        if (!this.form) throw new Error('TK Async Form: Form Element is missing!');
        this.registerSubmitListener();
    }

    registerSubmitListener() {
        const onSubmit = this.submit.bind(this);
        this.pushListener({
            event: 'submit',
            element: this.form!,
            action: onSubmit,
        });
    }

    submit(event: SubmitEvent) {
        if (!this.form) return;
        event.preventDefault();
        const formData = new FormData(this.form);
        const payload = this.outputAsJSON
            ? { [this.jsonKey]: JSON.stringify(this.formDataToArray(formData)) }
            : this.formDataToArray(formData);
        const { action } = this.form;
        fetchRequest({
            requestURL: action,
            payload,
            resolveHandler: this.handleResponse.bind(this),
        });
    }

    handleResponse(response: TKResponse<AsyncFormResponse>) {
        if (!response || !response.success) return;
        window.location.href = response.dataAsJson.redirectURL;
    }

    formDataToArray(formData: FormData): Record<string, string> | undefined {
        const result: Record<string, string> = {};

        try {
            formData.forEach((value, key) => {
                if (key in result) {
                    const existing = JSON.parse(result[key]);
                    if (Array.isArray(existing)) {
                        existing.push(value.toString());
                        result[key] = JSON.stringify(existing);
                    } else if (typeof existing === 'number') {
                        result[key] = JSON.stringify([existing.toString(), value.toString()]);
                    } else {
                        result[key] = JSON.stringify([existing, value.toString()]);
                    }
                } else {
                    result[key] = value.toString();
                }
            });

            return result;
        } catch (error) {
            console.error('Could not parse JSON correctly', error);
        }
    }
}
